/** Route table for the admin console (all behind <RequireAdmin>). */
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { RequireAdmin } from './components/AuthGate';
import { AppShell } from './components/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { LivePage } from './pages/LivePage';
import { ApprovalsPage } from './pages/ApprovalsPage';
import { UsersPage } from './pages/UsersPage';
import { AppVersionsPage } from './pages/AppVersionsPage';
import { InsightsPage } from './pages/InsightsPage';
import { ActivityReportPage } from './pages/ActivityReportPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { SyncMonitorPage } from './pages/SyncMonitorPage';
import { CatalogPage } from './pages/CatalogPage';
import { PdfsPage } from './pages/PdfsPage';
import { WishlistsPage } from './pages/WishlistsPage';
import { ScratchCardsPage } from './pages/ScratchCardsPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <RequireAdmin>
        <AppShell />
      </RequireAdmin>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'live', element: <LivePage /> },
      { path: 'approvals', element: <ApprovalsPage /> },
      { path: 'users', element: <UsersPage /> },
      { path: 'versions', element: <AppVersionsPage /> },
      { path: 'insights', element: <InsightsPage /> },
      { path: 'activity', element: <ActivityReportPage /> },
      { path: 'wishlists', element: <WishlistsPage /> },
      { path: 'scratch', element: <ScratchCardsPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'sync', element: <SyncMonitorPage /> },
      { path: 'catalog', element: <CatalogPage /> },
      { path: 'pdfs', element: <PdfsPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

export function App(): JSX.Element {
  return <RouterProvider router={router} />;
}
